export default __webpack_public_path__ + "static/media/7.448152b9.jpg";